import { CSSColors, TypeStudents } from '../enums'

export const TypeStudentNameAndColor = new Map<TypeStudents, Record<string, string>>([
  [TypeStudents.Payment, { name: 'Pago', color: CSSColors.GreenBrain }],
  [TypeStudents.Free, { name: 'Gratis', color: CSSColors.FreeLightBlue }],
  [TypeStudents.Inactive, { name: 'Inactivo', color: CSSColors.YellowBrain }],
  [TypeStudents.Reenroll, { name: 'Recursante', color: CSSColors.Gray700 }]
])
